import { mapActions } from "vuex";
import { types as Category } from "@/store/category";
import { types as Search } from "@/store/search";
import { adCart } from "@/libs/api.js";
import { types as Vi } from "@/store/vi";
import shareTip from "@/components/shareTip.vue"; //微信分享提示组件
import { simpleDebounce } from "@/libs/common.js";
const actions = mapActions({
  getNavList: Category.CATEGORY_NAV_LIST,
  getSearchList: Search.SEARCH_LIST,
  getGoodsDetail: Vi.GOODS_DETAIL,
});
export default {
  name: "Category",
  components: { shareTip },
  data() {
    return {
      link: `https://h5.${this.$uleUrl()}/yxd/community/item/itemPage/`,
      targetUrl: `https://h5.${this.$uleUrl()}/yxd/community`,
      isEmpty: "",
      searchValue: "",
      boxHeight: 0,
      sidebarWidth: 0,
      active: 0,
      currentNav: "", // 右侧顶部选中
      leftNavList: [],
      categoryNavShow: false,
      rightNavList: [],
      selected: {
        cateId: "",
        subCateId: "",
      },
      cont: [],
      query: {
        clientCallType: "h5",
        pageIndex: 1,
        pageSize: 500,
        cateId: 0,
        keyword: "",
        area: "",
      },
      showTip: false, // 微信分享提示
      // isMinWx: false, // 是否是小程序
      overShow: true, // 当前页遮罩
      loading: false,
      finished: false,
      isLoad: false,
      freshActType: "",
      finishedText: "",
      isShowRightTitle: true, // 右侧二级分类是否显示
      prodItems: false,
      popData: {
        listName: "",
        price: "",
        mkPrice: "",
        colors: [],
        sellNum: 12, // 接口数据缺失
        prodCount: 1, //起购数量  //接口数据缺失
        minNum: 1, // 接口数据缺失
        defItemId: "",
      },
      popActive: 0,
      sizeActive: 0,
      limit: false,
      storage: 100,
      isNewCustomer: false, //是否为新人
      ylyx_commodity_current_price:'',
      ylyx_commodity_original_price:'',
      isPilot:false,
      isYlxdsq:false,
    };
  },
  created() {
    if (this.$route.query.freshActType == 1) {
      this.query.listingTags = "1784"; //试点城市标签
      this.freshActType = this.$route.query.freshActType;
    }
    this.selected = JSON.parse(localStorage.getItem("ylxdsq.category") || "{}");
    // 获取adcode
    if (this.$browser().miniprogram) {
      this.query.area = this.getStorage("home", "home.AD_CODE_MIN");
    } else {
      this.query.area = this.getStorage("home", "home.AD_CODE");
    }
    if (this.$browser().ylxdsq || this.$browser().ulemax) {
      this.isYlxdsq = true;
      console.log('isYlxdsq',this.isYlxdsq)
      this.callPilotStatus();
    }else{
      console.log('h5分类的query',this.query)
      this.getNavList(this.query).then((res) => {
        this.overShow = false;
        res.data.category.forEach((item, index) => {
          this.leftNavList.push({
            text: item.name,
            id: item.id,
            children: [
              {
                id: item.id,
                imgUrl: "",
                level: 0,
                name: "全部",
                parent: null,
                parentId: 0,
                pinyin: "",
                recommendColorFlag: 0,
                relevancy: 0,
              },
            ].concat(item.children),
          });
          this.cont.push({ goods: [] });
          if (this.selected.cateId == item.id) {
            this.active = index;
          }
        });
        this.leftNavList.map((item, index) => {
          if (item.id == this.$route.query.categoryId) {
            this.active = index;
          }
        });
        if (this.leftNavList.length > 0) {
          this.rightNavList = this.leftNavList[this.active].children;
        }
        // 如果是北京,隐藏二级分类
        if (this.query.area.indexOf(110) == 0) {
          this.isShowRightTitle = false;
          this.query.cateId =
            this.selected.cateId || this.leftNavList[this.active].id;
        } else {
          this.isShowRightTitle = true;
          this.query.cateId =
            this.selected.subCateId ||
            this.leftNavList[this.active]["children"][0].id;
          this.currentNav =
            this.selected.subCateId ||
            this.leftNavList[this.active]["children"][0].id;
        }
        this.fetch();
      });
    }
    
  },
  mounted() {
    // 获取页面中间高度
    this.boxHeight =
      document.documentElement.clientHeight -
      document.querySelector(".search").clientHeight -
      10 +
      "px";
    this.sidebarWidth =
      document.querySelector(".van-sidebar").clientWidth + "px";
    document.querySelector(".category-nav").style.left = this.sidebarWidth;
    document.querySelector(".overlay").style.height =
      document.documentElement.clientHeight -
      document.querySelector(".search").clientHeight -
      10 +
      "px";
    this.isNewCustomer =
      localStorage.getItem("isNewCustomer") == 2 ? false : true;
  },
  methods: {
    ...actions,
    // 右侧箭头切换
    showMoreCategory() {
      this.categoryNavShow = !this.categoryNavShow;
    },
    // 优鲜APP中获取是否试点
    callPilotStatus: function() {
      let _this = this;
      window.dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
       window.dsBridge.register("getPilotStatusResult", function(s) {
        console.log('sssssss1111',s)
        if(s == 'true' || s == true){
          _this.isPilot = true;
          _this.query.listingTags = "1784";
          _this.query.area = _this.$cookies.get("pilotAreaId") || '';
          console.log('pilot', _this.$cookies.get("pilotAreaId"))
          console.log('app分类的query',_this.query)
        }else{
          _this.query.area = _this.getStorage("home", "home.AD_CODE") || ''
        }
        console.log('appquery',_this.query)
        _this.getNavList(_this.query).then((res) => {
          _this.overShow = false;
          res.data.category.forEach((item, index) => {
            _this.leftNavList.push({
              text: item.name,
              id: item.id,
              children: [
                {
                  id: item.id,
                  imgUrl: "",
                  level: 0,
                  name: "全部",
                  parent: null,
                  parentId: 0,
                  pinyin: "",
                  recommendColorFlag: 0,
                  relevancy: 0,
                },
              ].concat(item.children),
            });
            _this.cont.push({ goods: [] });
            if (_this.selected.cateId == item.id) {
              _this.active = index;
            }
          });
          _this.leftNavList.map((item, index) => {
            if (item.id == _this.$route.query.categoryId) {
              _this.active = index;
            }
          });
          if (_this.leftNavList.length > 0) {
            _this.rightNavList = _this.leftNavList[_this.active].children;
          }
          // 如果是北京,隐藏二级分类
          if (_this.query.area.indexOf(110) == 0) {
            _this.isShowRightTitle = false;
            _this.query.cateId =
              _this.selected.cateId || _this.leftNavList[_this.active].id;
          } else {
            _this.isShowRightTitle = true;
            _this.query.cateId =
              _this.selected.subCateId ||
              _this.leftNavList[_this.active]["children"][0].id;
            _this.currentNav =
              _this.selected.subCateId ||
              _this.leftNavList[_this.active]["children"][0].id;
          }
          _this.fetch();
        });
      });
    },
    searchClick() {
      let ua = navigator.userAgent.toLowerCase();
      console.log('uauauauaua',ua)
      console.log(ua.indexOf("ylxdsq"))
      console.log(ua.indexOf("ulemax"))
      console.log(ua.indexOf("ylxdsq") > 0 && ua.indexOf("ulemax") > -1)
      if(this.$browser().ylxdsq){
        console.log('优鲜1')
        if(this.$browser().ios){
          dsBridge.call("generalAction", { "type": "3", "ios_action": "UM_GoodsSearchController::0", "android_action":"action&&ui.YxGoodsSearchKeyWordActivity", "maxversion": "999&999", "minversion": "300&300", "needlogin": "false", "logTitle": "" })
        }else{
          dsBridge.call("generalAction", { "type": "3", "ios_action": "待填写", "android_action":"action&&ui.YxGoodsSearchKeyWordActivity", "maxversion": "999&999", "minversion": "300&300", "needlogin": "false", "logTitle": "" })
        }
      }
      else if(this.$browser().ulemax){
        console.log('四合一2')
        if(this.$browser().ios){
          dsBridge.call("generalAction", { "type": "3","router_action":"search", "ios_action": "UM_GoodsSearchController::0", "android_action":"action&&ui.YxGoodsSearchKeyWordActivity", "maxversion": "999&999", "minversion": "300&300", "needlogin": "false", "logTitle": "" })
        }else{
          dsBridge.call("generalAction", { "type": "3","router_action":"search", "ios_action": "待填写", "android_action":"action&&ui.YxGoodsSearchKeyWordActivity", "maxversion": "999&999", "minversion": "300&300", "needlogin": "false", "logTitle": "" })
        }
      }
      else{
        if (this.freshActType == "1") {
          this.toNext("/search/searchList", { freshActType: 1 });
        } else {
          this.toNext("/search/searchList");
        }
      }
    },
    setSelectedCate(type, value) {
      this.selected[type] = value;
      localStorage.setItem("ylxdsq.category", JSON.stringify(this.selected));
    },
    // 获取商品列表
    fetch() {
      this.getSearchList(this.query).then((res) => {
        this.loading = false;
        if (res.returnCode === "0000") {
          // 无数据
          if (res.data.Listings.length === 0) {
            this.finished = true;
          } else {
            // 活动列表下拉load事件
            if (
              document.querySelector(".van-tree-select__content").scrollTop ===
              0
            ) {
              setTimeout(() => {
                document
                  .querySelector(".van-tree-select__content")
                  .scrollTo(0, 1);
              }, 10);
            }
            res.data.Listings.forEach((item) => {
              if (~item.imgurl.indexOf("http://")) {
                item.imgurl = item.imgurl.replace("http://", "https://");
              }
            });
            this.query.pageIndex++;
            let totalPage = Math.floor(this.pageCount(res.data.totalCount));
            this.cont[0]["goods"] = this.cont[0]["goods"].concat(
              res.data.Listings
            );
            this.cont[0]["goods"].forEach((item) => {
              console.log("itemitemitemitemitemitem====", item);
              // // 如果有活动价则显示活动价
              // if(item.promotionDesc){
              // 	item.price = item.promotionDesc.listingPrice
              // }
              //新人且有活动并且在活动时间内的时候展示活动价
              // console.log("搜索数据");
              let now = new Date().valueOf();
              //有新人礼活动且在活动时间内显示活动价格，限时抢购商品直接显示活动期的抢购价
              if (item.promotionDesc) {
                //商品有活动
                let promotionDesc = item.promotionDesc;
                if (
                  now >= promotionDesc.startTime &&
                  now <= promotionDesc.endTime
                ) {
                  //商品在活动期内
                  if (
                    item.promotionIds.indexOf("6202") > -1 ||
                    (item.promotionIds.indexOf("6203") > -1 &&
                      this.isNewCustomer)
                  ) {
                    item.price = parseFloat(promotionDesc.listingPrice).toFixed(
                      2
                    );
                  } else {
                    //显示原价
                    item.price = parseFloat(item.minPrice).toFixed(2);
                  }
                } else {
                  item.price = parseFloat(item.minPrice).toFixed(2);
                }
              } else {
                item.price = parseFloat(item.minPrice).toFixed(2);
              }
            });
            if (this.query.pageIndex > totalPage) {
              this.finished = true;
              this.finishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.finished = false;
            }
          }
        } else {
          this.finished = true;
          this.finishedText = "我已到达底部, 暂无其他数据啦~~";
        }
      });
    },
    // 计算总页数
    pageCount(totalCount) {
      return (totalCount + this.query.pageSize - 1) / this.query.pageSize;
    },
    // 左侧切换
    changeTab(index) {
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      this.cont[0]["goods"] = [];
      this.rightNavList = this.leftNavList[index].children;
      this.currentNav = this.rightNavList[0].id;
      this.query.pageIndex = 1;
      this.query.cateId = this.currentNav;
      this.loading = false;
      this.finished = false;
      this.isLoad = true;
      this.setSelectedCate("cateId", this.leftNavList[index].id);
      this.setSelectedCate("subCateId", this.currentNav);
      if (index !== 0) {
        document
          .querySelector(".van-tree-select__content")
          .classList.add("left-top-radius");
        document
          .querySelector(".category-nav")
          .classList.add("left-top-radius");
      } else {
        document
          .querySelector(".van-tree-select__content")
          .classList.remove("left-top-radius");
        document
          .querySelector(".category-nav")
          .classList.remove("left-top-radius");
      }
      // this.fetch();
    },
    // 右侧点击
    rightNavChange(item) {
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      this.cont[0]["goods"] = [];
      this.query.cateId = item.id;
      this.currentNav = item.id;
      this.query.pageIndex = 1;
      this.loading = false;
      this.finished = false;
      this.isLoad = true;
      this.setSelectedCate("subCateId", this.currentNav);
    },
    // 加入购物车
    popCart(listId) {
      // 获取商品信息
      this.getGoodsDetail(listId).then((res) => {
        this.popData = Object.assign(this.popData, res);
        // 图片处理
        if (~this.popData.imgUrl.indexOf("http://")) {
          this.popData.imgUrl = this.popData.imgUrl.replace(
            "http://",
            "https://"
          );
        }
        this.storage = this.popData.colors[0].items[0].itemStorage;
        if (this.popData.limitWay == 0 || this.popData.limitWay > 7) {
          //不限购
          this.popData.prodCount = 1;
          this.popData.minNum = this.popData.limitNum;
        } else if (this.popData.limitWay == 4) {
          // 起售
          this.popData.minNum = this.popData.limitNum;
        }
        this.popData.colors.map((item, index) => {
          item.items.map((sItem, sindex) => {
            if (sItem.itemId == this.popData.defItemId) {
              this.popActive = index;
              this.sizeActive = sindex;
            }
          });
        });
        // this.popData.imgUrl = `https:${this.popData.imgUrl}`;
        console.log(this.popData);
        this.prodItems = true;
      });
    },
    // 切换颜色
    changColor(index, itemId, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.popActive = index;
      }
      if (this.sizeActive >= this.popData.colors[index]["items"].length) {
        this.sizeActive = this.popData.colors[index]["items"].length - 1;
        this.popData.defItemId = this.popData.colors[index]["items"][
          this.sizeActive
        ].itemId;
      }
      this.popData.defItemId = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemId;
      this.storage = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemStorage;
      //this.maxPrice、this.price 如果有一品多价也在此处处理
      this.popData.sharePrice = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemSalPrice;
      this.popData.marketPrice = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemMarketPrice;
    },
    // 切换规格
    changSize(index, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.sizeActive = index;
        this.popData.defItemId = e.target.getAttribute("itemId");
        this.storage = e.target.getAttribute("storage");
        //this.maxPrice、this.price 如果有一品多价也在此处处理
        this.popData.sharePrice = this.popData.colors[this.popActive]["items"][
          index
        ].itemSalPrice;
        this.popData.marketPrice = this.popData.colors[this.popActive]["items"][
          index
        ].itemMarketPrice;
        this.ylyx_commodity_current_price = this.popData.colors[this.popActive]["items"][index].itemSalPrice;
        this.ylyx_commodity_original_price = this.popData.colors[this.popActive]["items"][index].itemMarketPrice;
        if (this.limit) {
          // 商品有限购
          if (Number(this.popData.limitNum) > Number(this.storage)) {
            //限购数量超出库存时取最小
            this.popData.limitNum = this.storage;
          } else {
            // this.limitNum = limitNum
          }
        } else {
          this.storage = e.target.getAttribute("storage");
          if (Number(this.popData.minNum) > Number(this.storage)) {
            // 最少购买数大于库存 ,团购商品存在这个问题
            this.$toast("商品已售罄");
            this.prodCount = this.storage;
          }
        }
      }
      if (Number(this.prodCount) > Number(this.storage)) {
        this.popData.prodCount = this.storage;
      }
    },
    // 加入购物车
    addCart(listId) {
      let data = {
        listId: listId,
        itemId: this.popData.defItemId,
        itemCount: this.popData.prodCount,
        yxdId: this.getStorage("user", "user.STORE_ID"), //用户id
      };
      console.log('加购isPilot',this.isPilot)
      if (this.freshActType == 1 || this.isPilot) {
        data.cartType = "12";
      }
      adCart(data, "jsonCallback").then((data) => {
        if (data.returnCode === "0000") {
          this.prodItems = false;
          this.$toast("加入成功");
        }
      });
      //神策埋点
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_AddCart', {
        ylyx_commodity_sku_code: this.popData.defItemId,
        ylyx_commodity_name: this.popData.listName || '',
        ylyx_commodity_original_price: this.ylyx_commodity_original_price || this.popData.marketPrice,
        ylyx_commodity_current_price: this.ylyx_commodity_current_price || this.popData.sharePrice,
        item_id: listId,
        ylyx_commodity_count: this.popData.prodCount,
      });
    },
    // 分享
    share(item) {
      let link = this.link + item.listId;
      this.goodsShare(
        item.listName,
        item.listName,
        link,
        item.defImgUrl,
        item.listId,
        item.price,
        item.price,
        this.freshActType
      );
    },
    // 进入vi页
    toViPage(listId) {
      if (this.$route.query.name) {
        this.$router.push({
          path: "/item/itemPage/" + listId,
          query: {
            name: this.$route.query.name,
            latng: this.$route.query.latng,
            addr: this.$route.query.addr,
            city: this.$route.query.city,
            module: this.$route.query.module,
            freshActType: this.freshActType,
            from:'categoryList'
          },
        });
      } else {
        // 四合一
        if(this.$browser().ulemax){
          window.dsBridge.call("generalAction", {"type":"3","router_action":`prd&&listId::${listId}`})
        }else{
          this.$router.push({
            path: "/item/itemPage/" + listId,
              query: { freshActType: this.freshActType, from:'categoryList'},
          });
        }
      }
    },
    stepChangeDebounceRight: _.debounce(function(e) {
      let _this = this;
      console.log(e);
      _this.rightNavChange(e);
    }, 500),
    navChangeDebounceLeft: _.debounce(function(e) {
      let _this = this;
      console.log(e);
      _this.changeTab(e);
    }, 500),
  },
};
